module.exports = __webpack_public_path__ + "static/media/room-11.b96baee9.jpeg";